import {
    Tree,
    TreeItem,
    TreeItemLayout,
    Menu,
    MenuItem,
    MenuList,
    MenuPopover,
    MenuTrigger,
    Button,
    Text
} from "@fluentui/react-components";
import { MoreHorizontal20Regular, Delete24Regular } from "@fluentui/react-icons";
import React, { useState } from "react";
import { ChatSessionItem } from "../../Types/Chat/ChatSessionItem";

interface HistoryTreeProps {
    history?: Array<ChatSessionItem>;
    onDeleteItem?: (id: number) => void;
    onItemClick?: (item: number) => void;
    closeDrawer: () => void;
    itemSelected?: number;
    setItemSelected?: (item: number) => void;
    showTreeHeader?: boolean;
    title?: string;
}
export function HistoryTree({
    history,
    onDeleteItem,
    onItemClick,
    closeDrawer,
    itemSelected,
    setItemSelected,
    showTreeHeader = true,
    title
}: HistoryTreeProps) {
    const [topLevelOpen, setTopLevelOpen] = useState(true);
    const [selectedItem, setSelectedItem] = useState<number>(itemSelected ?? -1);
    const handleItemClick = (id: number) => {
        setSelectedItem(id);
        if (onItemClick) {
            onItemClick(id);
            setItemSelected?.(id);
            closeDrawer();
        } else {
            console.warn("onItemClick is not defined");
        }
    };

    const formatDate = (dateInput: Date | string) => {
        try {
            const date = dateInput instanceof Date ? dateInput : new Date(dateInput);

            const day = date.getDate().toString().padStart(2, '0');
            const month = (date.getMonth() + 1).toString().padStart(2, '0');
            const year = date.getFullYear();
            const hours = date.getHours().toString().padStart(2, '0');
            const minutes = date.getMinutes().toString().padStart(2, '0');

            return `${day}.${month}.${year} ${hours}:${minutes}`;
        } catch (error) {
            console.error("Error formatting date:", error);
            return "Invalid date";
        }
    };

    const renderHistoryItem = (item: ChatSessionItem) => {
        const isSelected = selectedItem === item.id;
        return (
            <TreeItem key={item.id} itemType="leaf">
                <TreeItemLayout
                    onClick={() => handleItemClick(item.id)}
                    style={{ padding: "0px 0px 0px 24px" }}
                    className={isSelected ? "bg-primary-light dark:bg-primary-dark w-full rounded-sm" : "w-full rounded-sm"}
                    actions={
                        <Menu>
                            <MenuTrigger disableButtonEnhancement>
                                <Button
                                    onClick={(e) => { e.stopPropagation() }}
                                    aria-label="More options"
                                    appearance="subtle"
                                    icon={<MoreHorizontal20Regular />}
                                />
                            </MenuTrigger>
                            <MenuPopover>
                                <MenuList>
                                    <MenuItem
                                        icon={<Delete24Regular />}
                                        onClick={(e) => {
                                            e.stopPropagation(); // Prevent event from bubbling to TreeItemLayout
                                            onDeleteItem?.(item.id);
                                        }}
                                    >
                                        Delete
                                    </MenuItem>
                                </MenuList>
                            </MenuPopover>
                        </Menu>
                    }
                >
                    <div
                        className="cursor-pointer w-full h-full flex flex-col"

                    >
                        <Text weight="medium">{item.name || "Untitled Chat"}</Text>
                        <Text size={200} className="text-xs opacity-70">
                            {formatDate(item.lastChangedAt)}
                        </Text>
                    </div>
                </TreeItemLayout>
            </TreeItem>
        );
    };

    if (!history || history.length === 0) {
        return null;
    }
    if (!showTreeHeader) {
        return (
            <div className="history-tree">
                <Tree>
                    {history.map(item => renderHistoryItem(item))}
                </Tree>
            </div>
        );
    }

    return (
        <div className="history-tree">
            <Tree>
                <TreeItem
                    open={topLevelOpen}
                    onClick={() => setTopLevelOpen(!topLevelOpen)}
                    itemType="branch"
                >
                    <TreeItemLayout>
                        <Text weight="semibold">{title}</Text>
                    </TreeItemLayout>
                    <Tree>
                        {history.map(item => renderHistoryItem(item))}
                    </Tree>
                </TreeItem>
            </Tree>
        </div>
    );
}